import { createAsyncThunk } from '@reduxjs/toolkit';

import { SliceNameEnum } from '@app/enums';
import { MarketingBanner } from '@app/models';
import { CmsGlobalService } from '@app/services';

export const fetchMarketingBanner = createAsyncThunk<
    MarketingBanner | null,
    { preview?: boolean; documentId?: string } | void,
    { rejectValue: string }
>(`${SliceNameEnum.CmsGlobal}/fetchMarketingBanner`, async (payload, { rejectWithValue }) => {
    try {
        const preview = payload && typeof payload === 'object' ? payload.preview : false;
        const documentId = payload && typeof payload === 'object' ? payload.documentId : undefined;
        const banner = await CmsGlobalService.instance.getMarketingBanner(preview, documentId);
        return banner;
    } catch (error) {
        const message = error instanceof Error ? error.message : 'Failed to fetch marketing banner';
        return rejectWithValue(message);
    }
});
